import { useEffect, useState } from 'react';

export const useDocumentWidth = () => {
  const [vw, setVw] = useState(document.documentElement.clientWidth || window.innerWidth || 0);

  useEffect(() => {
    const resizeFunc = () => {
      setVw(document.documentElement.clientWidth || window.innerWidth || 0);
    };

    window.addEventListener('resize', resizeFunc);
    return () => window.removeEventListener('resize', resizeFunc);
  }, []);

  return vw;
};
